import gql from "graphql-tag";

export const OC_GET_VERSION = gql`
  query getVersion {
    getVersion
  }
`;
